import React, { useEffect, useState } from 'react';
import { customStyle } from '../../Components/Style';
import Table from '../../Components/Table';
import moment from 'moment';
import Select from 'react-select';
import { Calendar } from 'antd';
import "react-datepicker/dist/react-datepicker.css";
import "../../Assets/Css/Holiday.scss";
import { useLocation, useNavigate } from "react-router-dom";
import Calendericon from "../../Assets/Images/Holiday/calendar";
import Listicon from "../../Assets/Images/Holiday/list";
import { getSpecialday } from "../../Services/Specialday/action";
import { connect } from "react-redux";
import { deleteRecord } from "../../Services/Delete/action";
import RoleWiseFeatureWrapper, {
  checkFeatureAccess,
} from "../../Lib/RoleWiseFeatureWrapper";
import ModulesList from "../../Assets/ModulesLiist";
import FeaturesList from "../../Assets/FeaturesList";
import Skeleton from 'react-loading-skeleton';
import EventsListsList from '../../Assets/Images/Attendance/EventsListsList';
import EventsListsCalendar from '../../Assets/Images/Attendance/EventsListsCalendar';

const Specialday = (props) => {
  const currentMonth = moment().month() + 1;
  const currentYear = moment().year();

  const [selectedMonth, setSelectedMonth] = useState({
    value: currentMonth,
    label: moment.months()[currentMonth - 1]
  });
  const [selectedYear, setSelectedYear] = useState({
    value: currentYear,
    label: currentYear
  });
  const [activeButton, setActiveButton] = useState("");
  const [inData, setInData] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const canView = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Specialday,
    Featur_Name: FeaturesList.View,
  });

  const canDelete = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Specialday,
    Featur_Name: FeaturesList.Delete,
  });

  const canEdit = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Specialday,
    Featur_Name: FeaturesList.Update,
  });

  useEffect(() => {
    if (location.pathname == "/specialday/calendar") {
      const path = location.pathname.slice(11);
      setActiveButton(path);
    } else {
      const path = location.pathname.slice(1);
      setActiveButton(path);
    }

    props?.getSpecialday();
  }, []);

  const handleClick = (buttonId, route) => {
    setActiveButton(buttonId);
    navigate(route);
  };

  const monthOptions = moment.months().map((month, index) => ({
    value: index + 1,
    label: month,
  }));

  const yearOptions = Array.from({ length: 11 }, (_, i) => ({
    value: currentYear - 5 + i,
    label: currentYear - 5 + i,
  }));

  const onPanelChange = (value, mode) => {
    const month = value.month() + 1;
    const year = value.year();
    setSelectedMonth({ value: month, label: moment.months()[month - 1] });
    setSelectedYear({ value: year, label: year });
  };

  const dateCellRender = (value) => {
    const date = value.format("DD-MM-YYYY");
    const specialday = inData?.find((specialday) => specialday?.Date?.value == date);

    if (specialday) {
      return (
        <div
          className="holiday-marker"
          onClick={() =>
            navigate("/specialday/view", {
              state: { data: specialday, from: location.pathname },
            })
          }
        >
          <span className="holiday-occasion">{specialday.Occasion?.value}</span>
        </div>
      );
    }

    return null;
  };

  const header = [
    { field: "Date" },
    { field: "Occasion" },
    { field: "Day" },
    { field: "Action" },
  ];

  useEffect(() => {
    const year = selectedYear?.value || currentYear;
    const month = selectedMonth?.value || currentMonth;

    const dbSpecialday = (props?.specialday || [])
      .map((item) => ({
        id: item?.id,
        date: moment(item?.date?.split(" ")[0]).format("YYYY-MM-DD"),
        occasion: item?.occasion,
        fromDb: true,
      }))
      .filter((item) => {
        const date = moment(item.date, "YYYY-MM-DD");
        return date.month() + 1 === month && date.year() === year;
      });

    const allSpecialday = [...dbSpecialday].reduce((acc, curr) => {
      if (!acc.find((item) => item.date === curr.date)) {
        acc.push(curr);
      }
      return acc;
    }, []).sort((a, b) => new Date(a.date) - new Date(b.date));

    setInData(
      allSpecialday.map((item) => ({
        checkbox: {
          value: item?.id,
          type: "checkbox",
        },
        Date: {
          value: moment(item.date).format("DD-MM-YYYY"),
          type: "date",
        },
        Occasion: {
          value: item.occasion,
          type: "text",
        },
        Day: {
          value: moment(item.date).format("dddd"),
          type: "text",
        },
        Action: {
          value: "/specialday/edit",
          value2: "/specialday/view",
          value3: item?.id,
          showIsDelete: canDelete && item?.fromDb,
          showIsEdit: canEdit && item?.fromDb,
          type: "action",
        },
        allData: {
          ...item,
        },
      }))
    );
  }, [props, selectedMonth, selectedYear]);

  const handleNavigate = () => {
    navigate("/specialday/add");
  };

  const handleClear = () => {
    setSelectedMonth({
      value: currentMonth,
      label: moment.months()[currentMonth - 1]
    });
    setSelectedYear({
      value: currentYear,
      label: currentYear
    });
  };

  return (
    <div className='holiday-container'>
      <div className="page-title">
        {
          props.loading ? (
            <Skeleton className='rounded-2' width={200} height={40} />
          ) : (
            <h4>Special Day</h4>
          )
        }
        <div className='add-holiday'>
          {
            props.loading ? (<Skeleton className='badge rounded-pill' width={100} height={40} />) : (
              <RoleWiseFeatureWrapper
                modules={props?.modules}
                features={props?.features}
                user={props?.user}
                ModuleName={ModulesList.Specialday}
                Featur_Name={FeaturesList.Create}
              >
                <div className="add-holiday-button">
                  <button className="custom-btn" onClick={handleNavigate}>
                    Add Special Day
                  </button>
                </div>
              </RoleWiseFeatureWrapper>
            )
          }
        </div>
      </div>

      {location.pathname === "/specialday" && (
        <div className='holiday-filters'>
          <div className='input-main'>
            {
              props.loading ? (
                <Skeleton className='rounded-2' width={200} height={40} />
              ) : (
                <div className="input-group">
                  <Select
                    options={monthOptions}
                    styles={{
                      ...customStyle,
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 2,
                      }),
                    }}
                    value={selectedMonth}
                    onChange={(val) => setSelectedMonth(val)}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                    placeholder="Month"
                  />
                </div>
              )
            }

            {
              props.loading ? (
                <Skeleton className='rounded-2' width={200} height={40} />
              ) : (
                <div className="input-group">
                  <Select
                    options={yearOptions}
                    styles={{
                      ...customStyle,
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 2,
                      }),
                    }}
                    value={selectedYear}
                    onChange={(val) => setSelectedYear(val)}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                    placeholder="Year"
                  />
                </div>
              )
            }
            <div className='add-holiday input-group'>
              {
                props.loading ? (
                  <Skeleton className='badge rounded-pill' width={100} height={40} />
                ) : (
                  <div className="add-holiday-button">
                    <button className="custom-btn" onClick={handleClear}>
                      Reset
                    </button>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      )}

      <div className="add-holiday">
        {
          props.loading ? (
            <Skeleton className="rounded-2" width={40} height={40} />
          ) : (
            <div className="navigation_btn">
              <button
                className={`btn1 ${activeButton === "specialday" ? "active" : ""
                  }`}
                onClick={() => handleClick("specialday", "/specialday")}
              >
                  <EventsListsList
                  color={activeButton === "specialday" ? "white" : "black"}
                  bgColor={activeButton === "specialday" ? "black" : "white"}
                />
              </button>
              <button
                className={`btn1 ${activeButton === "calendar" ? "active" : ""}`}
                onClick={() => handleClick("calendar", "/specialday/calendar")}
              >
                  <EventsListsCalendar
                  color={activeButton === "calendar" ? "white" : "black"}
                  bgColor={activeButton === "calendar" ? "black" : "white"}
                />
              </button>
            </div>
          )
        }
      </div>

      <div className='holiday-view'>
        {location.pathname === "/specialday" && (
          <div className='holiday-table'>
            {
              props.loading ? (
                <Skeleton count={5} width="100%" height={40} />
              ) : (
                <Table
                  deleteRecord={props?.deleteRecord}
                  loading={props?.loading}
                  data={inData}
                  header={header}
                  showIsView={canView}
                  footer={true}
                  count={inData?.length}
                  records={inData?.length}
                />
              )
            }
          </div>
        )}
        {location.pathname === "/specialday/calendar" && (
          <div className='holiday-calendar'>
            {
              props.loading ? (
                <Skeleton className='rounded-2' width="100%" height="100vh" />
              ) : (
                <Calendar
                  mode="month"
                  dateCellRender={dateCellRender}
                  onPanelChange={onPanelChange}
                />
              )
            }
          </div>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    specialday: state.specialdayReducer.holiday,
    loading: state.specialdayReducer.loading,
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    user: state.authenticationReducer.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSpecialday: () => {
      dispatch(getSpecialday());
    },
    deleteRecord: async (id, inputValue) => {
      await dispatch(deleteRecord(id, inputValue));
      await dispatch(getSpecialday());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Specialday);